module.exports = "/images/ck.svg?f4cd272726ee169c0e9ff25db7219ce1";